<template>

    <div class="tf"><!--任务-->
        <el-form  :model="formData" :rules="formRules" ref="formRef" label-width="80px" size="mini">
            <div class="formDiv flex">
                <el-form-item class="form-title" prop="wtname" :label="$t('form_entrust_company')" >
                    <el-select v-model="formData.wtname" placeholder="请选择委托公司"  filterable required clearable :disabled="edit">
                        <el-option
                                v-for="item in wtcompanyName"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.i_id">
                            <!--                                <span  style="display: inline-block;width: 100%">{{item.vc_name}}</span>-->
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="form-title" prop="dgname" label="代工公司" >
                    <el-select v-model="formData.dgname" placeholder="请选择代工公司" filterable required clearable :disabled="edit">
                        <el-option
                                v-for="itembm in dgcompanyName"
                                :key="itembm.i_id"
                                :label="itembm.vc_name"
                                :value="itembm.i_id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="form-title" prop="cjname" label="车间部门" >
                    <el-select v-model="formData.cjname" placeholder="请选择车间" filterable required clearable :disabled="edit">
                        <el-option
                                v-for="itemsq in cjList"
                                :key="itemsq.i_id"
                                :label="itemsq.vc_name"
                                :value="itemsq.i_id">
                            <!--                                <span style="display: inline-block;width: 100%">{{itemsq.vc_name}}</span>-->
                        </el-option>

                    </el-select>
                </el-form-item>
                <el-form-item class="form-title num " prop="num" label="No:" >
                    <span class="el-input el-input--small"  v-model="formData.num" style="color:#b3d268;font-size: 16px;font-style: italic;width: 150px;">{{formData.num}}</span>
                </el-form-item>
            </div>
            <div class="formDiv flex">
                <el-form-item class="form-title" prop="jgpro" label="产品" >
                    <el-select v-model="formData.jgpro" placeholder="请选择产品" filterable required clearable :disabled="edit">
                        <el-option
                                v-for="one in jgproList"
                                :key="one.i_id"
                                :label="one.vc_name"
                                :value="one.i_id">
                            <!--                                <span  style="display: inline-block;width: 100%">{{one.vc_name}}</span>-->
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="form-title" prop="quantity" label="数量:" >
                    <el-input  v-model="formData.quantity" >
                    </el-input>
                </el-form-item>
                <el-form-item class="form-title" prop="ckname" :label="$t('form_warehouse')" >
                    <el-select v-model="formData.ckname" placeholder="请输入仓库"  filterable required clearable :disabled="edit">
                        <el-option
                                v-for="item in ckList"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.i_id">
                            <!--                                <span  style="display: inline-block;width: 100%">{{item.vc_name}}</span>-->
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <div class="formDiv flex">
                <el-form-item class="form-title" prop="plantype" label="类型:" >
                    <el-select v-model="formData.plantype" placeholder="请选择计划类型" filterable required clearable :disabled="edit">
                        <el-option
                                v-for="one in plantypeList"
                                :key="one.i_id"
                                :label="one.vc_name"
                                :value="one.i_id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="form-title" prop="begin_time" label="开始时间:" >
                    <el-date-picker
                            v-model="formData.begin_time"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item class="form-title" prop="end_time" label="结束时间:" >
                    <el-date-picker
                            v-model="formData.end_time"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>


            </div>
            <div style="margin-bottom: 20px">
                <el-table
                        border
                        ref="multipleTable"
                        :data="tableData"
                        height="496"
                        tooltip-effect="dark"
                        style="width: 100%;">
                    <el-table-column
                            :label="$t('form_serial_number')"
                            align="left"
                            type="index"
                            width="55">
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="materials"
                            label="原辅料"
                            width=""
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="xqnum"
                            label="单吨需求量"
                            width=""
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="protype"
                            label="类型"
                            width=""
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column align="center"  width="50">
                        <template slot="header" slot-scope="scope">
                            <el-popover
                                    class="pop"
                                    placement="bottom-end"
                                    width="1200"
                                    trigger="manual"
                                    v-model="visible">
                                <template>
                                    <product-task v-if="visible==true" :productDetails="productDetails" @closePop="closePop" @transValue="transValue"></product-task>
                                </template>
                                <el-button class="addbtn" @click="popShow" slot="reference" :disabled="isbtn" ><i class="el-icon-plus"></i></el-button>
                            </el-popover>
                        </template>
                        <template  slot-scope="scope">
                            <div class="iconminus">
                                <span class="minus" @click="deleteRow(scope.row,scope.$index)"><i class="el-icon-minus"></i></span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="flex formbottom">
                <div style="width: 50%" class="formDiv ">
                    <el-form-item class="form-title" prop="vc_note" :label="$t('form_notes')" >
                        <el-input  v-model="formData.vc_note" >
                        </el-input>
                    </el-form-item>
                    <el-form-item class="form-title" prop="vc_lruname" label="录入人" >
                        <el-input  v-model="formData.vc_lruname" disabled>
                        </el-input>
                    </el-form-item>
                </div>
                <div style="width: 50%" class="formDiv ">
                    <el-form-item class="form-title" prop="plannum" label="生产计划编号" >
                        <el-input  v-model="formData.plannum" >
                        </el-input>
                    </el-form-item>

                    <el-form-item class="form-title" prop="date" label="录入时间" >
                        <el-input  v-model="formData.date" disabled>
                        </el-input>
                    </el-form-item>
                </div>
            </div>

        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">

            <el-button type="primary" @click="saveForm" :disabled="disabled" :class="baseerp+'btn'">保存</el-button>
            <el-button @click="cancel">{{$t('button_cancel')}}</el-button>
            <!--<el-button type="primary" @click="" :disabled="disabled">作废</el-button>
            <el-button type="primary" @click="" :disabled="disabled">中止</el-button>-->
        </div>
    </div>
</template>

<script>
    // import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    import ProductTask from "./ProductTask";
    export default {
        name: "TaskForm",
        components: {ProductTask},
        props:{
            taskForm:{
                type:Object,
                required:true,
            }
        },
        data() {
            return{
                gsname:"",
                bmname:"",
                dgsname:"",
                jgpro:"",
                groupid:0,
                formData:{
                    wtname:"",
                    dgname:"",
                    cjname:"",
                    dgsname:"",
                    jgpro:"",
                    num:"000000",
                    ckname:"",
                    vc_note:"",
                    plannum:"",
                    vc_lruname:"",
                    date:"",
                    quantity:'',
                    begin_time:"",
                    end_time:'',
                    plantype:"",
                    tableData:[]
                },
                formRules:{
                    /*gsname:[{required:true,message:"请选择公司",trigger:"change"}],
                    bmname:[{required:true,message:"请选择部门",trigger:"change"}],
                    sqName:[{required:true,message:"请填写申请人",trigger:"change"}],
                    jgpro:[{required:true,message:"请选择仓库",trigger:"change"}],
                    f_num:[{required:true,message:"请填写出库量",trigger:"blur"},],*/
                },

                wtcompanyName:[],
                dgcompanyName:[],
                cjList:[],
                ckList:[],
                personName:[],
                jgproList:[],
                plantypeList:[],
                tableData:[
                ],
                vc_note:"",
                f_num:"",
                visible:false,
                productDetails:{},
                /*beizhuDate:{
                    vc_note:"",
                    vc_lruname:"",
                    date:"",
                },*/
                vc_note:"",
                vc_lruname:"",
                date:"",
                disabled:false,
                isbtn:false,
                edit:false,
                data:{},
                i_id:0,
                state:0,
                qgsname:"",
                qckname:"",
                gsid:0,
                ckid:0,
                squid:0,
                sqName:"",
                index:0,
                pageSize:1,
                baseerp:""
            }
        },
        mounted() {
            this.baseerp=baseerp;
        },
        methods: {
            popShow(){
                this.visible=true;
                //console.log(this.visible)
                /*if (this.formData.gsname==''||this.formData.ckname==''){
                    this.$message.error("请选择公司或仓库")
                    return
                }else if(this.formData.gsname!=''&&this.formData.ckname!=''){
                    this.visible=true;
                }*/
                if (this.visible==true){
                    this.isbtn=true
                }
            },
            closePop(){
                this.visible=false;
                this.isbtn=false;
            },
            //产品列表
            transValue(value){
                //console.log(value,"------------")
                let arr=[...this.formData.tableData,...value];
                //console.log(arr,"arrrrrrrrrrrrr")
                /*const vc_pzid='vc_pzid';
                const vc_no='vc_no';
                const i_scid='i_scid';
                //console.log(item,"--item--",next)
                const newArr = arr.reduce((all,next)=>all.some((item)=>item[vc_pzid]==next[vc_pzid])?all:[...all,next],[]);
                const newArr2 = newArr.reduce((all,next)=>all.some((item)=>item[vc_no]==next[vc_no])?all:[...all,next],[]);
                const newArr3 = newArr2.reduce((all,next)=>all.some((item)=>item[i_scid]==next[i_scid])?all:[...all,next],[]);

*/
                let hash = {};
                arr = arr.reduce(function(item, next) {
                    hash[next.vc_pzid+"/"+next.vc_no+"/"+next.i_scid] ? '' : hash[next.vc_pzid+"/"+next.vc_no+"/"+next.i_scid] = true && item.push(next);
                    return item
                }, []);
                this.formData.tableData=arr;
                this.tableData=arr;
                //console.log("**arr**",newArr3)
            },
            deleteRow(value,index){
                this.index=index;
                if (value.i_id!=0){
                    this.$confirm('是否删除已保存产品','提示',{
                        confirmButtonText:'确定',
                        cancelButtonText:'取消',
                        type:'warning'
                    }).then(async()=>{
                        this.delPickingList(value.i_id);

                    }).catch(()=>{
                        this.$message({
                            type:'info',
                            message:'已取消删除'
                        })
                    })
                }else{
                    this.tableData.splice(this.index,1);
                    this.$message.success("删除成功");
                }
                // console.log(value,"-----")
            },
            saveForm(){},
            saveBOM(){},
            cancel(){
                //console.log(this.pageSize,"------")
                this.visible=false;
                this.$emit('close');

                //this.$emit('getEntrustCompanyHaveList')
            },
        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display: flex;
    }
    .item{
        width: 100%;
    }
    .pop .addbtn{
        border: none;
        padding: 0;
    }
    .el-icon-plus {
        font-size: 20px;
        color: #3e82e8;
        font-weight: bolder;
    }
    /deep/{
        .num .el-form-item__label {
            color: #b3d268;
            font-size: 16px;
            font-style: italic;
        }
        .num .el-form-item__content {
            width: 130px;
        }
        /*.el-date-editor.el-input, .el-date-editor.el-input__inner{
            width: 100%;
        }*/
        .formbottom .el-input{
            width: auto;
        }
    }
</style>